export enum ErrorCode {
SERIALIZATION_ILLEGAL_FORMAT = 601,
QUERY_ILLEGAL_ORDER_SUPPLIED = 602,
QUERY_ILLEGAL_FILTER_SUPPLIED = 603,
NOT_FOUND = 604,
SECURITY_EXCEPTION = 605,
INVALID_JWT_TOKEN = 606,
BLOCKED_FOR_PRODUCTIVE_USE = 607,
RATE_LIMIT_EXCEEDED = 608,
ADMIN_KEY_NOT_SET = 609,
ADMIN_KEY_REQUIRED = 610,
ADMIN_KEY_INVALID = 611,
NOT_AN_ACCESS_TOKEN = 612,
EXPIRED_JWT_TOKEN = 637,
DTO_CONVERSION_FAILED = 901,
EXECUTION_INTERRUPTED = 903,
MISSING_PERMISSION = 1001,
PASSWORD_REQUIREMENTS_NOT_MET = 1002,
INVALID_CREDENTIALS = 1003,
NO_CLIENT_AVAILABLE = 1004,
NO_USER_CONTEXT = 1005,
NO_CLIENT_CONTEXT = 1006,
NO_USER_CLIENT_CONTEXT = 1007,
DEAD_LOCK_DETECTED = 1008,
FEATURE_DISABLED = 1009
}